import router from './routes/router'
import {createApp} from 'vue';
import i18n from './language/i18n';
import api from './api/api';
import Master from "./templates/layouts/master.vue";
import SearchInput from "./templates/search/components/search-input.vue";
import Share from "./templates/search/components/share.vue";
import AdminSearch from "./templates/admin/components/search-input.vue";
import client from "./api/client";
import mitt from 'mitt';
import moment from 'moment';
import Spinner from './components/spinner/spinner';
import Loading from './components/spinner/loading';
import Modal from './components/modals/modal';
import InfinityScroll from './components/form/infinityScroll';
import BackBtn from './components/btn/back';
import VueResizeSensor from '@seregpie/vue-resize-sensor';
import DropZone from 'dropzone-vue';
import 'dropzone-vue/dist/dropzone-vue.common.css';

moment.locale('en_gb');
moment.updateLocale('en', {
    relativeTime: {
        future: "seconds ago",
        s: "seconds",
    }
});

window.emitter = mitt();
window.$api = api;
window.app = createApp(Master)
window.search = createApp(SearchInput)
window.share = createApp(Share)
window.adminSearch = createApp(AdminSearch)
app.component('spinner', Spinner)
app.component('loading', Loading)
app.component('modal', Modal)
app.component('backBtn', BackBtn)
app.component('resizeSensor', VueResizeSensor);
app.component('infinityScroll', InfinityScroll)
app.use(router)
app.use(DropZone)
app.use(i18n)
app.config.globalProperties.$client = client;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.emitter = emitter;

app.mount('#app');
search.mount('#search');
share.mount('#share');
adminSearch.mount('#admin-search');


